import { useMemo } from "react";
import RefreshButton from "../../../../../../common/components/refresh_button";


/**
 * EntregaObrasTopHeader
 */

type Props = {
  title: string;
  nomeEntregaObra: string | null;
  nomeChecklist: string | null;
  nomeCliente: string | null;
  nomeUnidade: string | null;
  additionalHeader?: React.ReactNode;
  returnButton?: boolean;
  onReload: () => void;

};

export const EntregaObrasTopHeader = ({
  title,
  nomeEntregaObra,
  nomeChecklist,
  nomeCliente,
  nomeUnidade,
  additionalHeader,
  returnButton = true,
  onReload,
}: Props) => {
  const headerObraInformation = useMemo(() => {
    return (

      <div className="w-full flex flex-col">
        <div className="w-full mt-2 text-black dark:text-white">
          <span className="font-extrabold text-xl mr-2"> Checklist de Entrega Obra | Entrega: </span>
          {nomeEntregaObra && (
            <>
              <span className="mx-1 font-normal text-base">{nomeEntregaObra}</span>
            </>
          )}
          <br />
          {nomeChecklist && (
            <><span className="mx-1 font-bold text-xl"> Checklist: </span>
              <span className="mx-1 font-normal text-base">{nomeChecklist}</span>
            </>
          )}
          <br />
          {nomeCliente && (
            <>
              <span className="mx-1 font-bold text-xl"> Cliente: </span>
              <span className="mx-1 font-normal text-base">{nomeCliente}</span>
            </>
          )}
          <br />
          {nomeUnidade && (
            <>
              <span className="mx-1 font-bold text-xl"> Unidade </span>
              <span className="mx-1 font-normal text-base">{nomeUnidade}</span>
            </>
          )}
        </div>
        {additionalHeader}
      </div>
    )
  }, [
    nomeEntregaObra,
    nomeChecklist,
    nomeCliente,
    additionalHeader,
  ]);

  return (
    <>
      <div className="w-full flex flex-col justify-between items-center">
        {
          returnButton &&
          <div className="w-full flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">{title}</h1>
              <RefreshButton onClick={onReload} />
            </div>
          </div>
        }

        {headerObraInformation}
      </div>
    </>
  );
};
